import type { HelpSlug } from "../articles";
import { en } from "./en";

/**
 * Article sources per language. A new language adds content/<lng>/ with the
 * same slugs (helpContent.test.ts checks); a missing language falls back to English.
 */
export const HELP_CONTENT: Record<string, Record<HelpSlug, string>> = { en };
